import { AdvancedSearchFieldModel } from "./../models/advanced-search-field";
import { backboneCollectionProperties } from "../../decorators/backbone-properties";

@backboneCollectionProperties({
    model: AdvancedSearchFieldModel
})
export class FieldsCollection extends Backbone.Collection<AdvancedSearchFieldModel> {
    constructor(options?) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/collections/fields.ts